export default "__VITE_ASSET__bBuBnmwM__"